export interface MonitoringResponseDto {
  actions: HTVAction[]
}

export interface HTVAction {
  id: string
  createdAt: Date
  modifiedAt: Date
  type: HTVActionType
  deviceId: string
}

export enum HTVActionType {
  CLEAR_DATA = 'CLEAR_DATA',
  POWER_OFF = 'POWER_OFF',
  REBOOT = 'REBOOT',
  SEND_LOGS = 'SEND_LOGS',
  TUNNEL = 'TUNNEL',
}
